
import React from 'react';
import './styles.scss';


export const DefaultLoader = ({ hidden }) => (
    <div className="default-loader" hidden={hidden}>
        <span className="custom-loader"></span>
    </div>
);